import { orgAddressFragment, orgContactFragment } from 'apollo/fragments';
import { gql } from 'graphql.macro';

export const parentClinicsTemplate = gql`
    query parentClinics(
        $filters: ClinicsFilters!
        $limit: Int!
        $offset: Int!
        $orderBy: String
        $orderDirection: OrderDirection
        $includeChildClinics: Boolean
        $includeLocalClinics: Boolean = false
    ) {
        parentClinics(
            filters: $filters
            limit: $limit
            offset: $offset
            orderBy: $orderBy
            orderDirection: $orderDirection
            includeChildClinics: $includeChildClinics
            includeLocalClinics: $includeLocalClinics
        ) {
            _id
            hitHorizonsId
            name
            officialName
            organizationNumber
            gln
            parentClinicId
            contact {
                ...orgContactFields
            }
            invoicing {
                costCenter
                vatNo
                invoiceAddress {
                    ...orgAddressFields
                }
                communication {
                    email
                }
            }
            isNotPickUpAndDeliveryPlace
            active
            externalInfo {
                externalId1
                externalId2
            }
            created {
                on
            }
            parentClinic {
                _id
                name
            }
            isWhiteLabeled
            localLabOwner {
                _id
                name
            }
            local
            ptjCustomerNumber
            crediFlow {
                partyID
            }
            localeFormat {
                language
                date
                number
            }
        }
    }
    ${orgContactFragment}
    ${orgAddressFragment}
`;
